import { Controller } from 'stimulus'
import Google from 'mixins/google'

export default class extends Google(Controller) {

  connect() {
    this.googleConnect()
  }

  googleConnected() {
    this.autocomplete = new google.maps.places.Autocomplete(this.element, {
      fields: ["name"]
    });
  }
}

